var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptomusLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4692 18.9079L42.0769 1.36181C40.7077 0.569501 39 0.569501 37.6231 1.36181L7.23077 18.9079C5.85385 19.7002 5 21.1772 5 22.7695V57.8618C5 59.4465 5.85385 60.9233 7.23077 61.7233L37.6231 79.2699C38.3 79.6622 39.0692 79.8622 39.8539 79.8622C40.6385 79.8622 41.4077 79.6545 42.0846 79.2699L72.4769 61.7233C73.8539 60.931 74.7077 59.4542 74.7077 57.8618V22.7695C74.7077 21.1849 73.8539 19.7079 72.4769 18.9079H72.4692ZM40.5385 38.1387C40.1154 38.3849 39.5846 38.3849 39.1615 38.1387L9.61539 21.0848L39.1615 4.03104C39.5769 3.79258 40.1231 3.79258 40.5385 4.03104L70.0846 21.0848L40.5385 38.1387ZM37.6231 40.8002C37.8385 40.9233 38.0692 41.031 38.3154 41.1156V76.1002L8.76923 59.0541C8.34615 58.8079 8.07692 58.3542 8.07692 57.8618V23.7464L37.6231 40.8002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptomusLogo);
export default __webpack_public_path__ + "static/media/CryptomusLogo.bf638848eb10110b00c7be3aed5292cf.svg";
export { ForwardRef as ReactComponent };